import { render, staticRenderFns } from "./addAdBodyDialog.vue?vue&type=template&id=5c82f2cc&scoped=true"
import script from "./addAdBodyDialog.vue?vue&type=script&lang=js"
export * from "./addAdBodyDialog.vue?vue&type=script&lang=js"
import style0 from "./addAdBodyDialog.vue?vue&type=style&index=0&id=5c82f2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82f2cc",
  null
  
)

export default component.exports